
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3b41"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3b41"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("alWdG", function(module, exports) {
/*!
  * Bootstrap data.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dom/data.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const elementMap = new Map();
    const data = {
        set (element, key, instance) {
            if (!elementMap.has(element)) elementMap.set(element, new Map());
            const instanceMap = elementMap.get(element); // make it clear we only want one instance per element
            // can be removed later when multiple key/instances are fine to be used
            if (!instanceMap.has(key) && instanceMap.size !== 0) {
                // eslint-disable-next-line no-console
                console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
                return;
            }
            instanceMap.set(key, instance);
        },
        get (element, key) {
            if (elementMap.has(element)) return elementMap.get(element).get(key) || null;
            return null;
        },
        remove (element, key) {
            if (!elementMap.has(element)) return;
            const instanceMap = elementMap.get(element);
            instanceMap.delete(key); // free up element references if there are no instances left for an element
            if (instanceMap.size === 0) elementMap.delete(element);
        }
    };
    return data;
});

});

parcelRegister("fKNxC", function(module, exports) {
/*!
  * Bootstrap event-handler.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const getjQuery = ()=>{
        const { jQuery: jQuery } = window;
        if (jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return jQuery;
        return null;
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dom/event-handler.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
    const stripNameRegex = /\..*/;
    const stripUidRegex = /::\d+$/;
    const eventRegistry = {}; // Events storage
    let uidEvent = 1;
    const customEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
    const customEventsRegex = /^(mouseenter|mouseleave)/i;
    const nativeEvents = new Set([
        "click",
        "dblclick",
        "mouseup",
        "mousedown",
        "contextmenu",
        "mousewheel",
        "DOMMouseScroll",
        "mouseover",
        "mouseout",
        "mousemove",
        "selectstart",
        "selectend",
        "keydown",
        "keypress",
        "keyup",
        "orientationchange",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointerleave",
        "pointercancel",
        "gesturestart",
        "gesturechange",
        "gestureend",
        "focus",
        "blur",
        "change",
        "reset",
        "select",
        "submit",
        "focusin",
        "focusout",
        "load",
        "unload",
        "beforeunload",
        "resize",
        "move",
        "DOMContentLoaded",
        "readystatechange",
        "error",
        "abort",
        "scroll"
    ]);
    /**
   * ------------------------------------------------------------------------
   * Private methods
   * ------------------------------------------------------------------------
   */ function getUidEvent(element, uid) {
        return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
    }
    function getEvent(element) {
        const uid = getUidEvent(element);
        element.uidEvent = uid;
        eventRegistry[uid] = eventRegistry[uid] || {};
        return eventRegistry[uid];
    }
    function bootstrapHandler(element, fn) {
        return function handler(event) {
            event.delegateTarget = element;
            if (handler.oneOff) EventHandler.off(element, event.type, fn);
            return fn.apply(element, [
                event
            ]);
        };
    }
    function bootstrapDelegationHandler(element, selector, fn) {
        return function handler(event) {
            const domElements = element.querySelectorAll(selector);
            for(let { target: target } = event; target && target !== this; target = target.parentNode){
                for(let i = domElements.length; i--;)if (domElements[i] === target) {
                    event.delegateTarget = target;
                    if (handler.oneOff) EventHandler.off(element, event.type, selector, fn);
                    return fn.apply(target, [
                        event
                    ]);
                }
            } // To please ESLint
            return null;
        };
    }
    function findHandler(events, handler, delegationSelector = null) {
        const uidEventList = Object.keys(events);
        for(let i = 0, len = uidEventList.length; i < len; i++){
            const event = events[uidEventList[i]];
            if (event.originalHandler === handler && event.delegationSelector === delegationSelector) return event;
        }
        return null;
    }
    function normalizeParams(originalTypeEvent, handler, delegationFn) {
        const delegation = typeof handler === "string";
        const originalHandler = delegation ? delegationFn : handler;
        let typeEvent = getTypeEvent(originalTypeEvent);
        const isNative = nativeEvents.has(typeEvent);
        if (!isNative) typeEvent = originalTypeEvent;
        return [
            delegation,
            originalHandler,
            typeEvent
        ];
    }
    function addHandler(element, originalTypeEvent, handler, delegationFn, oneOff) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        if (!handler) {
            handler = delegationFn;
            delegationFn = null;
        } // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
        // this prevents the handler from being dispatched the same way as mouseover or mouseout does
        if (customEventsRegex.test(originalTypeEvent)) {
            const wrapFn = (fn)=>{
                return function(event) {
                    if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
                };
            };
            if (delegationFn) delegationFn = wrapFn(delegationFn);
            else handler = wrapFn(handler);
        }
        const [delegation, originalHandler, typeEvent] = normalizeParams(originalTypeEvent, handler, delegationFn);
        const events = getEvent(element);
        const handlers = events[typeEvent] || (events[typeEvent] = {});
        const previousFn = findHandler(handlers, originalHandler, delegation ? handler : null);
        if (previousFn) {
            previousFn.oneOff = previousFn.oneOff && oneOff;
            return;
        }
        const uid = getUidEvent(originalHandler, originalTypeEvent.replace(namespaceRegex, ""));
        const fn = delegation ? bootstrapDelegationHandler(element, handler, delegationFn) : bootstrapHandler(element, handler);
        fn.delegationSelector = delegation ? handler : null;
        fn.originalHandler = originalHandler;
        fn.oneOff = oneOff;
        fn.uidEvent = uid;
        handlers[uid] = fn;
        element.addEventListener(typeEvent, fn, delegation);
    }
    function removeHandler(element, events, typeEvent, handler, delegationSelector) {
        const fn = findHandler(events[typeEvent], handler, delegationSelector);
        if (!fn) return;
        element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
        delete events[typeEvent][fn.uidEvent];
    }
    function removeNamespacedHandlers(element, events, typeEvent, namespace) {
        const storeElementEvent = events[typeEvent] || {};
        Object.keys(storeElementEvent).forEach((handlerKey)=>{
            if (handlerKey.includes(namespace)) {
                const event = storeElementEvent[handlerKey];
                removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
            }
        });
    }
    function getTypeEvent(event) {
        // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
        event = event.replace(stripNameRegex, "");
        return customEvents[event] || event;
    }
    const EventHandler = {
        on (element, event, handler, delegationFn) {
            addHandler(element, event, handler, delegationFn, false);
        },
        one (element, event, handler, delegationFn) {
            addHandler(element, event, handler, delegationFn, true);
        },
        off (element, originalTypeEvent, handler, delegationFn) {
            if (typeof originalTypeEvent !== "string" || !element) return;
            const [delegation, originalHandler, typeEvent] = normalizeParams(originalTypeEvent, handler, delegationFn);
            const inNamespace = typeEvent !== originalTypeEvent;
            const events = getEvent(element);
            const isNamespace = originalTypeEvent.startsWith(".");
            if (typeof originalHandler !== "undefined") {
                // Simplest case: handler is passed, remove that listener ONLY.
                if (!events || !events[typeEvent]) return;
                removeHandler(element, events, typeEvent, originalHandler, delegation ? handler : null);
                return;
            }
            if (isNamespace) Object.keys(events).forEach((elementEvent)=>{
                removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            });
            const storeElementEvent = events[typeEvent] || {};
            Object.keys(storeElementEvent).forEach((keyHandlers)=>{
                const handlerKey = keyHandlers.replace(stripUidRegex, "");
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) {
                    const event = storeElementEvent[keyHandlers];
                    removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
                }
            });
        },
        trigger (element, event, args) {
            if (typeof event !== "string" || !element) return null;
            const $ = getjQuery();
            const typeEvent = getTypeEvent(event);
            const inNamespace = event !== typeEvent;
            const isNative = nativeEvents.has(typeEvent);
            let jQueryEvent;
            let bubbles = true;
            let nativeDispatch = true;
            let defaultPrevented = false;
            let evt = null;
            if (inNamespace && $) {
                jQueryEvent = $.Event(event, args);
                $(element).trigger(jQueryEvent);
                bubbles = !jQueryEvent.isPropagationStopped();
                nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
                defaultPrevented = jQueryEvent.isDefaultPrevented();
            }
            if (isNative) {
                evt = document.createEvent("HTMLEvents");
                evt.initEvent(typeEvent, bubbles, true);
            } else evt = new CustomEvent(event, {
                bubbles: bubbles,
                cancelable: true
            });
             // merge custom information in our event
            if (typeof args !== "undefined") Object.keys(args).forEach((key)=>{
                Object.defineProperty(evt, key, {
                    get () {
                        return args[key];
                    }
                });
            });
            if (defaultPrevented) evt.preventDefault();
            if (nativeDispatch) element.dispatchEvent(evt);
            if (evt.defaultPrevented && typeof jQueryEvent !== "undefined") jQueryEvent.preventDefault();
            return evt;
        }
    };
    return EventHandler;
});

});

parcelRegister("jB4uE", function(module, exports) {
/*!
  * Bootstrap manipulator.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dom/manipulator.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ function normalizeData(val) {
        if (val === "true") return true;
        if (val === "false") return false;
        if (val === Number(val).toString()) return Number(val);
        if (val === "" || val === "null") return null;
        return val;
    }
    function normalizeDataKey(key) {
        return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
    }
    const Manipulator = {
        setDataAttribute (element, key, value) {
            element.setAttribute(`data-bs-${normalizeDataKey(key)}`, value);
        },
        removeDataAttribute (element, key) {
            element.removeAttribute(`data-bs-${normalizeDataKey(key)}`);
        },
        getDataAttributes (element) {
            if (!element) return {};
            const attributes = {};
            Object.keys(element.dataset).filter((key)=>key.startsWith("bs")).forEach((key)=>{
                let pureKey = key.replace(/^bs/, "");
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
                attributes[pureKey] = normalizeData(element.dataset[key]);
            });
            return attributes;
        },
        getDataAttribute (element, key) {
            return normalizeData(element.getAttribute(`data-bs-${normalizeDataKey(key)}`));
        },
        offset (element) {
            const rect = element.getBoundingClientRect();
            return {
                top: rect.top + window.pageYOffset,
                left: rect.left + window.pageXOffset
            };
        },
        position (element) {
            return {
                top: element.offsetTop,
                left: element.offsetLeft
            };
        }
    };
    return Manipulator;
});

});

parcelRegister("dDQCV", function(module, exports) {
/*!
  * Bootstrap selector-engine.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const isElement = (obj)=>{
        if (!obj || typeof obj !== "object") return false;
        if (typeof obj.jquery !== "undefined") obj = obj[0];
        return typeof obj.nodeType !== "undefined";
    };
    const isVisible = (element)=>{
        if (!isElement(element) || element.getClientRects().length === 0) return false;
        return getComputedStyle(element).getPropertyValue("visibility") === "visible";
    };
    const isDisabled = (element)=>{
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains("disabled")) return true;
        if (typeof element.disabled !== "undefined") return element.disabled;
        return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dom/selector-engine.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const NODE_TEXT = 3;
    const SelectorEngine = {
        find (selector, element = document.documentElement) {
            return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
        },
        findOne (selector, element = document.documentElement) {
            return Element.prototype.querySelector.call(element, selector);
        },
        children (element, selector) {
            return [].concat(...element.children).filter((child)=>child.matches(selector));
        },
        parents (element, selector) {
            const parents = [];
            let ancestor = element.parentNode;
            while(ancestor && ancestor.nodeType === Node.ELEMENT_NODE && ancestor.nodeType !== NODE_TEXT){
                if (ancestor.matches(selector)) parents.push(ancestor);
                ancestor = ancestor.parentNode;
            }
            return parents;
        },
        prev (element, selector) {
            let previous = element.previousElementSibling;
            while(previous){
                if (previous.matches(selector)) return [
                    previous
                ];
                previous = previous.previousElementSibling;
            }
            return [];
        },
        next (element, selector) {
            let next = element.nextElementSibling;
            while(next){
                if (next.matches(selector)) return [
                    next
                ];
                next = next.nextElementSibling;
            }
            return [];
        },
        focusableChildren (element) {
            const focusables = [
                "a",
                "button",
                "input",
                "textarea",
                "select",
                "details",
                "[tabindex]",
                '[contenteditable="true"]'
            ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(", ");
            return this.find(focusables, element).filter((el)=>!isDisabled(el) && isVisible(el));
        }
    };
    return SelectorEngine;
});

});

parcelRegister("1qjah", function(module, exports) {


/*!
  * Bootstrap base-component.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("alWdG")), (parcelRequire("fKNxC")));
})(module.exports, function(Data, EventHandler) {
    "use strict";
    const _interopDefaultLegacy = (e)=>e && typeof e === "object" && "default" in e ? e : {
            default: e
        };
    const Data__default = /*#__PURE__*/ _interopDefaultLegacy(Data);
    const EventHandler__default = /*#__PURE__*/ _interopDefaultLegacy(EventHandler);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const MILLISECONDS_MULTIPLIER = 1000;
    const TRANSITION_END = "transitionend"; // Shoutout AngusCroll (https://goo.gl/pxwQGp)
    const getTransitionDurationFromElement = (element)=>{
        if (!element) return 0;
         // Get transition-duration of the element
        let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
        const floatTransitionDuration = Number.parseFloat(transitionDuration);
        const floatTransitionDelay = Number.parseFloat(transitionDelay); // Return 0 if element or transition duration is not found
        if (!floatTransitionDuration && !floatTransitionDelay) return 0;
         // If multiple durations are defined, take the first
        transitionDuration = transitionDuration.split(",")[0];
        transitionDelay = transitionDelay.split(",")[0];
        return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    };
    const triggerTransitionEnd = (element)=>{
        element.dispatchEvent(new Event(TRANSITION_END));
    };
    const isElement = (obj)=>{
        if (!obj || typeof obj !== "object") return false;
        if (typeof obj.jquery !== "undefined") obj = obj[0];
        return typeof obj.nodeType !== "undefined";
    };
    const getElement = (obj)=>{
        if (isElement(obj)) // it's a jQuery object or a node element
        return obj.jquery ? obj[0] : obj;
        if (typeof obj === "string" && obj.length > 0) return document.querySelector(obj);
        return null;
    };
    const execute = (callback)=>{
        if (typeof callback === "function") callback();
    };
    const executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
        if (!waitForTransition) {
            execute(callback);
            return;
        }
        const durationPadding = 5;
        const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
        let called = false;
        const handler = ({ target: target })=>{
            if (target !== transitionElement) return;
            called = true;
            transitionElement.removeEventListener(TRANSITION_END, handler);
            execute(callback);
        };
        transitionElement.addEventListener(TRANSITION_END, handler);
        setTimeout(()=>{
            if (!called) triggerTransitionEnd(transitionElement);
        }, emulatedDuration);
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): base-component.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const VERSION = "5.1.3";
    class BaseComponent {
        constructor(element){
            element = getElement(element);
            if (!element) return;
            this._element = element;
            Data__default.default.set(this._element, this.constructor.DATA_KEY, this);
        }
        dispose() {
            Data__default.default.remove(this._element, this.constructor.DATA_KEY);
            EventHandler__default.default.off(this._element, this.constructor.EVENT_KEY);
            Object.getOwnPropertyNames(this).forEach((propertyName)=>{
                this[propertyName] = null;
            });
        }
        _queueCallback(callback, element, isAnimated = true) {
            executeAfterTransition(callback, element, isAnimated);
        }
        /** Static */ static getInstance(element) {
            return Data__default.default.get(getElement(element), this.DATA_KEY);
        }
        static getOrCreateInstance(element, config = {}) {
            return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
        }
        static get VERSION() {
            return VERSION;
        }
        static get NAME() {
            throw new Error('You have to implement the static method "NAME", for each component!');
        }
        static get DATA_KEY() {
            return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
            return `.${this.DATA_KEY}`;
        }
    }
    return BaseComponent;
});

});

parcelRegister("sxHqA", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return (parcelRequire("kcPJk")).popperGenerator; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("iMqqi")).default; });
$parcel$export(module.exports, "createPopperBase", function () { return (parcelRequire("kcPJk")).createPopper; });
$parcel$export(module.exports, "createPopper", function () { return (parcelRequire("coKYj")).createPopper; });
$parcel$export(module.exports, "createPopperLite", function () { return (parcelRequire("idR5b")).createPopper; });

var $9y4xT = parcelRequire("9y4xT");

var $lVSMY = parcelRequire("lVSMY");

var $kcPJk = parcelRequire("kcPJk");
var $iMqqi = parcelRequire("iMqqi");

var $coKYj = parcelRequire("coKYj");

var $idR5b = parcelRequire("idR5b");
$parcel$exportWildcard(module.exports, $9y4xT);
$parcel$exportWildcard(module.exports, $lVSMY);

});
parcelRegister("9y4xT", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $6f3ad0b1952eb857$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $6f3ad0b1952eb857$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $6f3ad0b1952eb857$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $6f3ad0b1952eb857$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $6f3ad0b1952eb857$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $6f3ad0b1952eb857$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $6f3ad0b1952eb857$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $6f3ad0b1952eb857$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $6f3ad0b1952eb857$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $6f3ad0b1952eb857$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $6f3ad0b1952eb857$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $6f3ad0b1952eb857$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $6f3ad0b1952eb857$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $6f3ad0b1952eb857$export$803cd8101b6c182b; });
$parcel$export(module.exports, "beforeRead", function () { return $6f3ad0b1952eb857$export$421679a7c3d56e; });
$parcel$export(module.exports, "read", function () { return $6f3ad0b1952eb857$export$aafa59e2e03f2942; });
$parcel$export(module.exports, "afterRead", function () { return $6f3ad0b1952eb857$export$6964f6c886723980; });
$parcel$export(module.exports, "beforeMain", function () { return $6f3ad0b1952eb857$export$c65e99957a05207c; });
$parcel$export(module.exports, "main", function () { return $6f3ad0b1952eb857$export$f22da7240b7add18; });
$parcel$export(module.exports, "afterMain", function () { return $6f3ad0b1952eb857$export$bab79516f2d662fe; });
$parcel$export(module.exports, "beforeWrite", function () { return $6f3ad0b1952eb857$export$8d4d2d70e7d46032; });
$parcel$export(module.exports, "write", function () { return $6f3ad0b1952eb857$export$68d8715fc104d294; });
$parcel$export(module.exports, "afterWrite", function () { return $6f3ad0b1952eb857$export$70a6e5159acce2e6; });
$parcel$export(module.exports, "modifierPhases", function () { return $6f3ad0b1952eb857$export$d087d3878fdf71d5; });
var $6f3ad0b1952eb857$export$1e95b668f3b82d = "top";
var $6f3ad0b1952eb857$export$40e543e69a8b3fbb = "bottom";
var $6f3ad0b1952eb857$export$79ffe56a765070d2 = "right";
var $6f3ad0b1952eb857$export$eabcd2c8791e7bf4 = "left";
var $6f3ad0b1952eb857$export$dfb5619354ba860 = "auto";
var $6f3ad0b1952eb857$export$aec2ce47c367b8c3 = [
    $6f3ad0b1952eb857$export$1e95b668f3b82d,
    $6f3ad0b1952eb857$export$40e543e69a8b3fbb,
    $6f3ad0b1952eb857$export$79ffe56a765070d2,
    $6f3ad0b1952eb857$export$eabcd2c8791e7bf4
];
var $6f3ad0b1952eb857$export$b3571188c770cc5a = "start";
var $6f3ad0b1952eb857$export$bd5df0f255a350f8 = "end";
var $6f3ad0b1952eb857$export$390fd549c5303b4d = "clippingParents";
var $6f3ad0b1952eb857$export$d7b7311ec04a3e8f = "viewport";
var $6f3ad0b1952eb857$export$ae5ab1c730825774 = "popper";
var $6f3ad0b1952eb857$export$ca50aac9f3ba507f = "reference";
var $6f3ad0b1952eb857$export$368f9a87e87fa4e1 = /*#__PURE__*/ $6f3ad0b1952eb857$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $6f3ad0b1952eb857$export$b3571188c770cc5a,
        placement + "-" + $6f3ad0b1952eb857$export$bd5df0f255a350f8
    ]);
}, []);
var $6f3ad0b1952eb857$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($6f3ad0b1952eb857$export$aec2ce47c367b8c3, [
    $6f3ad0b1952eb857$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $6f3ad0b1952eb857$export$b3571188c770cc5a,
        placement + "-" + $6f3ad0b1952eb857$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $6f3ad0b1952eb857$export$421679a7c3d56e = "beforeRead";
var $6f3ad0b1952eb857$export$aafa59e2e03f2942 = "read";
var $6f3ad0b1952eb857$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $6f3ad0b1952eb857$export$c65e99957a05207c = "beforeMain";
var $6f3ad0b1952eb857$export$f22da7240b7add18 = "main";
var $6f3ad0b1952eb857$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $6f3ad0b1952eb857$export$8d4d2d70e7d46032 = "beforeWrite";
var $6f3ad0b1952eb857$export$68d8715fc104d294 = "write";
var $6f3ad0b1952eb857$export$70a6e5159acce2e6 = "afterWrite";
var $6f3ad0b1952eb857$export$d087d3878fdf71d5 = [
    $6f3ad0b1952eb857$export$421679a7c3d56e,
    $6f3ad0b1952eb857$export$aafa59e2e03f2942,
    $6f3ad0b1952eb857$export$6964f6c886723980,
    $6f3ad0b1952eb857$export$c65e99957a05207c,
    $6f3ad0b1952eb857$export$f22da7240b7add18,
    $6f3ad0b1952eb857$export$bab79516f2d662fe,
    $6f3ad0b1952eb857$export$8d4d2d70e7d46032,
    $6f3ad0b1952eb857$export$68d8715fc104d294,
    $6f3ad0b1952eb857$export$70a6e5159acce2e6
];

});

parcelRegister("lVSMY", function(module, exports) {

$parcel$export(module.exports, "applyStyles", function () { return (parcelRequire("fUpMP")).default; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("goZPI")).default; });
$parcel$export(module.exports, "computeStyles", function () { return (parcelRequire("fVEtF")).default; });
$parcel$export(module.exports, "eventListeners", function () { return (parcelRequire("a6g97")).default; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("eOgWD")).default; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("fBHN2")).default; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("8IP3S")).default; });
$parcel$export(module.exports, "popperOffsets", function () { return (parcelRequire("bTkSB")).default; });
$parcel$export(module.exports, "preventOverflow", function () { return (parcelRequire("eqP9q")).default; });

var $fUpMP = parcelRequire("fUpMP");

var $goZPI = parcelRequire("goZPI");

var $fVEtF = parcelRequire("fVEtF");

var $a6g97 = parcelRequire("a6g97");

var $eOgWD = parcelRequire("eOgWD");

var $fBHN2 = parcelRequire("fBHN2");

var $8IP3S = parcelRequire("8IP3S");

var $bTkSB = parcelRequire("bTkSB");

var $eqP9q = parcelRequire("eqP9q");

});
parcelRegister("fUpMP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b95016ace06ef6ef$export$2e2bcd8739ae039; });

var $85XJ2 = parcelRequire("85XJ2");

var $1zHK9 = parcelRequire("1zHK9");
// and applies them to the HTMLElements such as popper and arrow
function $b95016ace06ef6ef$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $1zHK9.isHTMLElement)(element) || !(0, $85XJ2.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $b95016ace06ef6ef$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $1zHK9.isHTMLElement)(element) || !(0, $85XJ2.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $b95016ace06ef6ef$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $b95016ace06ef6ef$var$applyStyles,
    effect: $b95016ace06ef6ef$var$effect,
    requires: [
        "computeStyles"
    ]
};

});
parcelRegister("85XJ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e4d1e9b91a05538$export$2e2bcd8739ae039; });
function $5e4d1e9b91a05538$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("1zHK9", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $125afdd8416f3003$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $125afdd8416f3003$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $125afdd8416f3003$export$af51f0f06c0f328a; });

var $4Za1X = parcelRequire("4Za1X");
function $125afdd8416f3003$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $4Za1X.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $125afdd8416f3003$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $4Za1X.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $125afdd8416f3003$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $4Za1X.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("4Za1X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a14a3cd1f26f0dd$export$2e2bcd8739ae039; });
function $3a14a3cd1f26f0dd$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("goZPI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf0ed9fa8abf7ce3$export$2e2bcd8739ae039; });

var $h636q = parcelRequire("h636q");

var $dDhUD = parcelRequire("dDhUD");

var $hwHlb = parcelRequire("hwHlb");

var $7MV0X = parcelRequire("7MV0X");

var $gzQ2A = parcelRequire("gzQ2A");

var $hIJXu = parcelRequire("hIJXu");

var $leA0l = parcelRequire("leA0l");

var $79TfF = parcelRequire("79TfF");

var $9y4xT = parcelRequire("9y4xT");
var $bf0ed9fa8abf7ce3$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $leA0l.default)(typeof padding !== "number" ? padding : (0, $79TfF.default)(padding, (0, $9y4xT.basePlacements)));
};
function $bf0ed9fa8abf7ce3$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h636q.default)(state.placement);
    var axis = (0, $gzQ2A.default)(basePlacement);
    var isVertical = [
        (0, $9y4xT.left),
        (0, $9y4xT.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $bf0ed9fa8abf7ce3$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dDhUD.default)(arrowElement);
    var minProp = axis === "y" ? (0, $9y4xT.top) : (0, $9y4xT.left);
    var maxProp = axis === "y" ? (0, $9y4xT.bottom) : (0, $9y4xT.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $7MV0X.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $hIJXu.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $bf0ed9fa8abf7ce3$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $hwHlb.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $bf0ed9fa8abf7ce3$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $bf0ed9fa8abf7ce3$var$arrow,
    effect: $bf0ed9fa8abf7ce3$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});
parcelRegister("h636q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c725674cde0404ba$export$2e2bcd8739ae039; });

function $c725674cde0404ba$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("dDhUD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ecccfeee847f14c$export$2e2bcd8739ae039; });

var $49eUB = parcelRequire("49eUB");
function $9ecccfeee847f14c$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $49eUB.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("49eUB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $305391e52373e74c$export$2e2bcd8739ae039; });

var $1zHK9 = parcelRequire("1zHK9");

var $lqVuf = parcelRequire("lqVuf");

var $4Za1X = parcelRequire("4Za1X");

var $aRKrv = parcelRequire("aRKrv");
function $305391e52373e74c$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $1zHK9.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $lqVuf.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $lqVuf.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $1zHK9.isElement)(element) ? (0, $4Za1X.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $aRKrv.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("lqVuf", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $f9a89e6594356445$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $f9a89e6594356445$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $f9a89e6594356445$export$2077e0241d6afd3c; });
var $f9a89e6594356445$export$8960430cfd85939f = Math.max;
var $f9a89e6594356445$export$96ec731ed4dcb222 = Math.min;
var $f9a89e6594356445$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("aRKrv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e92e12d88cba59d$export$2e2bcd8739ae039; });

var $hP0AU = parcelRequire("hP0AU");
function $7e92e12d88cba59d$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $hP0AU.default)());
}

});
parcelRegister("hP0AU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf97a91f8ca3a90e$export$2e2bcd8739ae039; });
function $cf97a91f8ca3a90e$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});




parcelRegister("hwHlb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc270b6429a8f3bf$export$2e2bcd8739ae039; });

var $1zHK9 = parcelRequire("1zHK9");
function $cc270b6429a8f3bf$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $1zHK9.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("7MV0X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ab93df94269a774$export$2e2bcd8739ae039; });

var $4Za1X = parcelRequire("4Za1X");

var $85XJ2 = parcelRequire("85XJ2");

var $fRe1z = parcelRequire("fRe1z");

var $1zHK9 = parcelRequire("1zHK9");

var $lnTmr = parcelRequire("lnTmr");

var $728qg = parcelRequire("728qg");

var $hP0AU = parcelRequire("hP0AU");
function $5ab93df94269a774$var$getTrueOffsetParent(element) {
    if (!(0, $1zHK9.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $fRe1z.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $5ab93df94269a774$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $hP0AU.default)());
    var isIE = /Trident/i.test((0, $hP0AU.default)());
    if (isIE && (0, $1zHK9.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $fRe1z.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $728qg.default)(element);
    if ((0, $1zHK9.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $1zHK9.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $85XJ2.default)(currentNode)) < 0){
        var css = (0, $fRe1z.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $5ab93df94269a774$export$2e2bcd8739ae039(element) {
    var window = (0, $4Za1X.default)(element);
    var offsetParent = $5ab93df94269a774$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lnTmr.default)(offsetParent) && (0, $fRe1z.default)(offsetParent).position === "static")offsetParent = $5ab93df94269a774$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $85XJ2.default)(offsetParent) === "html" || (0, $85XJ2.default)(offsetParent) === "body" && (0, $fRe1z.default)(offsetParent).position === "static")) return window;
    return offsetParent || $5ab93df94269a774$var$getContainingBlock(element) || window;
}

});
parcelRegister("fRe1z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8b6af34e2fa71bf$export$2e2bcd8739ae039; });

var $4Za1X = parcelRequire("4Za1X");
function $b8b6af34e2fa71bf$export$2e2bcd8739ae039(element) {
    return (0, $4Za1X.default)(element).getComputedStyle(element);
}

});

parcelRegister("lnTmr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f916b08331e46e36$export$2e2bcd8739ae039; });

var $85XJ2 = parcelRequire("85XJ2");
function $f916b08331e46e36$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $85XJ2.default)(element)) >= 0;
}

});

parcelRegister("728qg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51ef40db7c237258$export$2e2bcd8739ae039; });

var $85XJ2 = parcelRequire("85XJ2");

var $okFwL = parcelRequire("okFwL");

var $1zHK9 = parcelRequire("1zHK9");
function $51ef40db7c237258$export$2e2bcd8739ae039(element) {
    if ((0, $85XJ2.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $1zHK9.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $okFwL.default)(element) // fallback
    );
}

});
parcelRegister("okFwL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04924665f14e76da$export$2e2bcd8739ae039; });

var $1zHK9 = parcelRequire("1zHK9");
function $04924665f14e76da$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $1zHK9.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("gzQ2A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c118486eaeb2c7fe$export$2e2bcd8739ae039; });
function $c118486eaeb2c7fe$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});

parcelRegister("hIJXu", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $ce6a321bee9dfe7a$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $ce6a321bee9dfe7a$export$86c8af6d3ef0b4a; });

var $lqVuf = parcelRequire("lqVuf");
function $ce6a321bee9dfe7a$export$f28d906d67a997f3(min, value, max) {
    return (0, $lqVuf.max)(min, (0, $lqVuf.min)(value, max));
}
function $ce6a321bee9dfe7a$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $ce6a321bee9dfe7a$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("leA0l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f756d58ddfe23fc8$export$2e2bcd8739ae039; });

var $auZ2e = parcelRequire("auZ2e");
function $f756d58ddfe23fc8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $auZ2e.default)(), paddingObject);
}

});
parcelRegister("auZ2e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a4c0d035cb3a05a$export$2e2bcd8739ae039; });
function $7a4c0d035cb3a05a$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("79TfF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0158538a3d56fdfb$export$2e2bcd8739ae039; });
function $0158538a3d56fdfb$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("fVEtF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b98b93e06b1349e6$export$2e2bcd8739ae039; });

var $9y4xT = parcelRequire("9y4xT");

var $7MV0X = parcelRequire("7MV0X");

var $4Za1X = parcelRequire("4Za1X");

var $okFwL = parcelRequire("okFwL");

var $fRe1z = parcelRequire("fRe1z");

var $h636q = parcelRequire("h636q");

var $dyvNY = parcelRequire("dyvNY");

var $lqVuf = parcelRequire("lqVuf");
var $b98b93e06b1349e6$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $b98b93e06b1349e6$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $lqVuf.round)(x * dpr) / dpr || 0,
        y: (0, $lqVuf.round)(y * dpr) / dpr || 0
    };
}
function $b98b93e06b1349e6$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $9y4xT.left);
    var sideY = (0, $9y4xT.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $7MV0X.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $4Za1X.default)(popper)) {
            offsetParent = (0, $okFwL.default)(popper);
            if ((0, $fRe1z.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $9y4xT.top) || (placement === (0, $9y4xT.left) || placement === (0, $9y4xT.right)) && variation === (0, $9y4xT.end)) {
            sideY = (0, $9y4xT.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $9y4xT.left) || (placement === (0, $9y4xT.top) || placement === (0, $9y4xT.bottom)) && variation === (0, $9y4xT.end)) {
            sideX = (0, $9y4xT.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $b98b93e06b1349e6$var$unsetSides);
    var _ref4 = roundOffsets === true ? $b98b93e06b1349e6$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $4Za1X.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $b98b93e06b1349e6$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $h636q.default)(state.placement),
        variation: (0, $dyvNY.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $b98b93e06b1349e6$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $b98b93e06b1349e6$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $b98b93e06b1349e6$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $b98b93e06b1349e6$var$computeStyles,
    data: {}
};

});
parcelRegister("dyvNY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9de71f22554e14d1$export$2e2bcd8739ae039; });
function $9de71f22554e14d1$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});


parcelRegister("a6g97", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75a6fd2e6bef2954$export$2e2bcd8739ae039; });

var $4Za1X = parcelRequire("4Za1X");
var $75a6fd2e6bef2954$var$passive = {
    passive: true
};
function $75a6fd2e6bef2954$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $4Za1X.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $75a6fd2e6bef2954$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $75a6fd2e6bef2954$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $75a6fd2e6bef2954$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $75a6fd2e6bef2954$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $75a6fd2e6bef2954$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $75a6fd2e6bef2954$var$effect,
    data: {}
};

});

parcelRegister("eOgWD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac82e10f8577b4f2$export$2e2bcd8739ae039; });

var $d30gv = parcelRequire("d30gv");

var $h636q = parcelRequire("h636q");

var $3MdR4 = parcelRequire("3MdR4");

var $iMqqi = parcelRequire("iMqqi");

var $6o2H6 = parcelRequire("6o2H6");

var $9y4xT = parcelRequire("9y4xT");

var $dyvNY = parcelRequire("dyvNY");
function $ac82e10f8577b4f2$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h636q.default)(placement) === (0, $9y4xT.auto)) return [];
    var oppositePlacement = (0, $d30gv.default)(placement);
    return [
        (0, $3MdR4.default)(placement),
        oppositePlacement,
        (0, $3MdR4.default)(oppositePlacement)
    ];
}
function $ac82e10f8577b4f2$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h636q.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d30gv.default)(preferredPlacement)
    ] : $ac82e10f8577b4f2$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h636q.default)(placement) === (0, $9y4xT.auto) ? (0, $6o2H6.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h636q.default)(placement);
        var isStartVariation = (0, $dyvNY.default)(placement) === (0, $9y4xT.start);
        var isVertical = [
            (0, $9y4xT.top),
            (0, $9y4xT.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $iMqqi.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $9y4xT.right) : (0, $9y4xT.left) : isStartVariation ? (0, $9y4xT.bottom) : (0, $9y4xT.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d30gv.default)(mainVariationSide);
        var altVariationSide = (0, $d30gv.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $ac82e10f8577b4f2$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $ac82e10f8577b4f2$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("d30gv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97fbc2d327d26e57$export$2e2bcd8739ae039; });
var $97fbc2d327d26e57$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $97fbc2d327d26e57$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $97fbc2d327d26e57$var$hash[matched];
    });
}

});

parcelRegister("3MdR4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c009a1dabf61f71$export$2e2bcd8739ae039; });
var $2c009a1dabf61f71$var$hash = {
    start: "end",
    end: "start"
};
function $2c009a1dabf61f71$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2c009a1dabf61f71$var$hash[matched];
    });
}

});

parcelRegister("iMqqi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dac134c6fe9b594e$export$2e2bcd8739ae039; });

var $7y0Q4 = parcelRequire("7y0Q4");

var $okFwL = parcelRequire("okFwL");

var $49eUB = parcelRequire("49eUB");

var $fiFDP = parcelRequire("fiFDP");

var $dhCXz = parcelRequire("dhCXz");

var $9y4xT = parcelRequire("9y4xT");

var $1zHK9 = parcelRequire("1zHK9");

var $leA0l = parcelRequire("leA0l");

var $79TfF = parcelRequire("79TfF");
function $dac134c6fe9b594e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $9y4xT.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $9y4xT.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $9y4xT.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $leA0l.default)(typeof padding !== "number" ? padding : (0, $79TfF.default)(padding, (0, $9y4xT.basePlacements)));
    var altContext = elementContext === (0, $9y4xT.popper) ? (0, $9y4xT.reference) : (0, $9y4xT.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $7y0Q4.default)((0, $1zHK9.isElement)(element) ? element : element.contextElement || (0, $okFwL.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $49eUB.default)(state.elements.reference);
    var popperOffsets = (0, $fiFDP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $dhCXz.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $9y4xT.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $9y4xT.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $9y4xT.right),
                (0, $9y4xT.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $9y4xT.top),
                (0, $9y4xT.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("7y0Q4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57ec5bf82d382956$export$2e2bcd8739ae039; });

var $9y4xT = parcelRequire("9y4xT");

var $gRRX7 = parcelRequire("gRRX7");

var $fsQfp = parcelRequire("fsQfp");

var $gJes1 = parcelRequire("gJes1");

var $7MV0X = parcelRequire("7MV0X");

var $okFwL = parcelRequire("okFwL");

var $fRe1z = parcelRequire("fRe1z");

var $1zHK9 = parcelRequire("1zHK9");

var $49eUB = parcelRequire("49eUB");

var $728qg = parcelRequire("728qg");

var $hwHlb = parcelRequire("hwHlb");

var $85XJ2 = parcelRequire("85XJ2");

var $dhCXz = parcelRequire("dhCXz");

var $lqVuf = parcelRequire("lqVuf");
function $57ec5bf82d382956$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $49eUB.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $57ec5bf82d382956$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $9y4xT.viewport) ? (0, $dhCXz.default)((0, $gRRX7.default)(element, strategy)) : (0, $1zHK9.isElement)(clippingParent) ? $57ec5bf82d382956$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $dhCXz.default)((0, $fsQfp.default)((0, $okFwL.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $57ec5bf82d382956$var$getClippingParents(element) {
    var clippingParents = (0, $gJes1.default)((0, $728qg.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $fRe1z.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $1zHK9.isHTMLElement)(element) ? (0, $7MV0X.default)(element) : element;
    if (!(0, $1zHK9.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $1zHK9.isElement)(clippingParent) && (0, $hwHlb.default)(clippingParent, clipperElement) && (0, $85XJ2.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $57ec5bf82d382956$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $57ec5bf82d382956$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $57ec5bf82d382956$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $lqVuf.max)(rect.top, accRect.top);
        accRect.right = (0, $lqVuf.min)(rect.right, accRect.right);
        accRect.bottom = (0, $lqVuf.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $lqVuf.max)(rect.left, accRect.left);
        return accRect;
    }, $57ec5bf82d382956$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("gRRX7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c47b726c6a7a40ba$export$2e2bcd8739ae039; });

var $4Za1X = parcelRequire("4Za1X");

var $okFwL = parcelRequire("okFwL");

var $c7PEe = parcelRequire("c7PEe");

var $aRKrv = parcelRequire("aRKrv");
function $c47b726c6a7a40ba$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $4Za1X.default)(element);
    var html = (0, $okFwL.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $aRKrv.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $c7PEe.default)(element),
        y: y
    };
}

});
parcelRegister("c7PEe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d3e33acc1a95131$export$2e2bcd8739ae039; });

var $49eUB = parcelRequire("49eUB");

var $okFwL = parcelRequire("okFwL");

var $1Ljhr = parcelRequire("1Ljhr");
function $8d3e33acc1a95131$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $49eUB.default)((0, $okFwL.default)(element)).left + (0, $1Ljhr.default)(element).scrollLeft;
}

});
parcelRegister("1Ljhr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $148922e1fea9bc12$export$2e2bcd8739ae039; });

var $4Za1X = parcelRequire("4Za1X");
function $148922e1fea9bc12$export$2e2bcd8739ae039(node) {
    var win = (0, $4Za1X.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("fsQfp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b421ffce3e6b8859$export$2e2bcd8739ae039; });

var $okFwL = parcelRequire("okFwL");

var $fRe1z = parcelRequire("fRe1z");

var $c7PEe = parcelRequire("c7PEe");

var $1Ljhr = parcelRequire("1Ljhr");

var $lqVuf = parcelRequire("lqVuf");
function $b421ffce3e6b8859$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $okFwL.default)(element);
    var winScroll = (0, $1Ljhr.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $lqVuf.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $lqVuf.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $c7PEe.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $fRe1z.default)(body || html).direction === "rtl") x += (0, $lqVuf.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("gJes1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2dc0ef437716eec$export$2e2bcd8739ae039; });

var $1ujnu = parcelRequire("1ujnu");

var $728qg = parcelRequire("728qg");

var $4Za1X = parcelRequire("4Za1X");

var $9Ve03 = parcelRequire("9Ve03");
function $c2dc0ef437716eec$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $1ujnu.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $4Za1X.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9Ve03.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($c2dc0ef437716eec$export$2e2bcd8739ae039((0, $728qg.default)(target)));
}

});
parcelRegister("1ujnu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11579fd3735e44c8$export$2e2bcd8739ae039; });

var $728qg = parcelRequire("728qg");

var $9Ve03 = parcelRequire("9Ve03");

var $85XJ2 = parcelRequire("85XJ2");

var $1zHK9 = parcelRequire("1zHK9");
function $11579fd3735e44c8$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $85XJ2.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $1zHK9.isHTMLElement)(node) && (0, $9Ve03.default)(node)) return node;
    return $11579fd3735e44c8$export$2e2bcd8739ae039((0, $728qg.default)(node));
}

});
parcelRegister("9Ve03", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73944c01c98a3d45$export$2e2bcd8739ae039; });

var $fRe1z = parcelRequire("fRe1z");
function $73944c01c98a3d45$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $fRe1z.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("dhCXz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9abb157a473322cd$export$2e2bcd8739ae039; });
function $9abb157a473322cd$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("fiFDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b238d68fa15b7365$export$2e2bcd8739ae039; });

var $h636q = parcelRequire("h636q");

var $dyvNY = parcelRequire("dyvNY");

var $gzQ2A = parcelRequire("gzQ2A");

var $9y4xT = parcelRequire("9y4xT");
function $b238d68fa15b7365$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h636q.default)(placement) : null;
    var variation = placement ? (0, $dyvNY.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $9y4xT.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $9y4xT.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $9y4xT.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $9y4xT.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $gzQ2A.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $9y4xT.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $9y4xT.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("6o2H6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a6712fd05cba2cf$export$2e2bcd8739ae039; });

var $dyvNY = parcelRequire("dyvNY");

var $9y4xT = parcelRequire("9y4xT");

var $iMqqi = parcelRequire("iMqqi");

var $h636q = parcelRequire("h636q");
function $4a6712fd05cba2cf$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $9y4xT.placements) : _options$allowedAutoP;
    var variation = (0, $dyvNY.default)(placement);
    var placements = variation ? flipVariations ? (0, $9y4xT.variationPlacements) : (0, $9y4xT.variationPlacements).filter(function(placement) {
        return (0, $dyvNY.default)(placement) === variation;
    }) : (0, $9y4xT.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $iMqqi.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h636q.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("fBHN2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5cc477af2170115$export$2e2bcd8739ae039; });

var $9y4xT = parcelRequire("9y4xT");

var $iMqqi = parcelRequire("iMqqi");
function $b5cc477af2170115$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $b5cc477af2170115$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $9y4xT.top),
        (0, $9y4xT.right),
        (0, $9y4xT.bottom),
        (0, $9y4xT.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $b5cc477af2170115$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $iMqqi.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $iMqqi.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $b5cc477af2170115$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $b5cc477af2170115$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $b5cc477af2170115$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $b5cc477af2170115$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $b5cc477af2170115$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $b5cc477af2170115$var$hide
};

});

parcelRegister("8IP3S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $659a0a8808d5ad9e$export$2e2bcd8739ae039; });

var $h636q = parcelRequire("h636q");

var $9y4xT = parcelRequire("9y4xT");
function $659a0a8808d5ad9e$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h636q.default)(placement);
    var invertDistance = [
        (0, $9y4xT.left),
        (0, $9y4xT.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $9y4xT.left),
        (0, $9y4xT.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $659a0a8808d5ad9e$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $9y4xT.placements).reduce(function(acc, placement) {
        acc[placement] = $659a0a8808d5ad9e$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $659a0a8808d5ad9e$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $659a0a8808d5ad9e$var$offset
};

});

parcelRegister("bTkSB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a850704736ee680$export$2e2bcd8739ae039; });

var $fiFDP = parcelRequire("fiFDP");
function $8a850704736ee680$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $fiFDP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8a850704736ee680$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8a850704736ee680$var$popperOffsets,
    data: {}
};

});

parcelRegister("eqP9q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a81b2bf2514ee8da$export$2e2bcd8739ae039; });

var $9y4xT = parcelRequire("9y4xT");

var $h636q = parcelRequire("h636q");

var $gzQ2A = parcelRequire("gzQ2A");

var $lTa8X = parcelRequire("lTa8X");

var $hIJXu = parcelRequire("hIJXu");

var $dDhUD = parcelRequire("dDhUD");

var $7MV0X = parcelRequire("7MV0X");

var $iMqqi = parcelRequire("iMqqi");

var $dyvNY = parcelRequire("dyvNY");

var $auZ2e = parcelRequire("auZ2e");

var $lqVuf = parcelRequire("lqVuf");
function $a81b2bf2514ee8da$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $iMqqi.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h636q.default)(state.placement);
    var variation = (0, $dyvNY.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $gzQ2A.default)(basePlacement);
    var altAxis = (0, $lTa8X.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $9y4xT.top) : (0, $9y4xT.left);
        var altSide = mainAxis === "y" ? (0, $9y4xT.bottom) : (0, $9y4xT.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $9y4xT.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $9y4xT.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dDhUD.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $auZ2e.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $hIJXu.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $7MV0X.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $hIJXu.within)(tether ? (0, $lqVuf.min)(min, tetherMin) : min, offset, tether ? (0, $lqVuf.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $9y4xT.top) : (0, $9y4xT.left);
        var _altSide = mainAxis === "x" ? (0, $9y4xT.bottom) : (0, $9y4xT.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $9y4xT.top),
            (0, $9y4xT.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $hIJXu.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $hIJXu.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a81b2bf2514ee8da$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $a81b2bf2514ee8da$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("lTa8X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef69a5314c3eb27$export$2e2bcd8739ae039; });
function $fef69a5314c3eb27$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});



parcelRegister("kcPJk", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $eb5d0e2e3a324caf$export$ed5e13716264f202; });
$parcel$export(module.exports, "createPopper", function () { return $eb5d0e2e3a324caf$export$8f7491d57c8f97a9; });

var $5CBw9 = parcelRequire("5CBw9");

var $dDhUD = parcelRequire("dDhUD");

var $gJes1 = parcelRequire("gJes1");

var $7MV0X = parcelRequire("7MV0X");

var $5fXRX = parcelRequire("5fXRX");

var $fFrQ5 = parcelRequire("fFrQ5");

var $3hqCk = parcelRequire("3hqCk");

var $iMqqi = parcelRequire("iMqqi");

var $1zHK9 = parcelRequire("1zHK9");
var $eb5d0e2e3a324caf$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $eb5d0e2e3a324caf$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $eb5d0e2e3a324caf$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $eb5d0e2e3a324caf$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $eb5d0e2e3a324caf$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $1zHK9.isElement)(reference) ? (0, $gJes1.default)(reference) : reference.contextElement ? (0, $gJes1.default)(reference.contextElement) : [],
                    popper: (0, $gJes1.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $5fXRX.default)((0, $3hqCk.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$eb5d0e2e3a324caf$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $5CBw9.default)(reference, (0, $7MV0X.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $dDhUD.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $fFrQ5.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$eb5d0e2e3a324caf$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $eb5d0e2e3a324caf$export$8f7491d57c8f97a9 = /*#__PURE__*/ $eb5d0e2e3a324caf$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("5CBw9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $417d9a91d79c5297$export$2e2bcd8739ae039; });

var $49eUB = parcelRequire("49eUB");

var $lRvaE = parcelRequire("lRvaE");

var $85XJ2 = parcelRequire("85XJ2");

var $1zHK9 = parcelRequire("1zHK9");

var $c7PEe = parcelRequire("c7PEe");

var $okFwL = parcelRequire("okFwL");

var $9Ve03 = parcelRequire("9Ve03");

var $lqVuf = parcelRequire("lqVuf");
function $417d9a91d79c5297$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $lqVuf.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $lqVuf.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $417d9a91d79c5297$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $1zHK9.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $1zHK9.isHTMLElement)(offsetParent) && $417d9a91d79c5297$var$isElementScaled(offsetParent);
    var documentElement = (0, $okFwL.default)(offsetParent);
    var rect = (0, $49eUB.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $85XJ2.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9Ve03.default)(documentElement)) scroll = (0, $lRvaE.default)(offsetParent);
        if ((0, $1zHK9.isHTMLElement)(offsetParent)) {
            offsets = (0, $49eUB.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $c7PEe.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("lRvaE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fea6ba14e049872e$export$2e2bcd8739ae039; });

var $1Ljhr = parcelRequire("1Ljhr");

var $4Za1X = parcelRequire("4Za1X");

var $1zHK9 = parcelRequire("1zHK9");

var $j12iD = parcelRequire("j12iD");
function $fea6ba14e049872e$export$2e2bcd8739ae039(node) {
    if (node === (0, $4Za1X.default)(node) || !(0, $1zHK9.isHTMLElement)(node)) return (0, $1Ljhr.default)(node);
    else return (0, $j12iD.default)(node);
}

});
parcelRegister("j12iD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd7fe4f617b9e817$export$2e2bcd8739ae039; });
function $dd7fe4f617b9e817$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("5fXRX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d3ccb41b24fd6ad$export$2e2bcd8739ae039; });

var $9y4xT = parcelRequire("9y4xT");
function $3d3ccb41b24fd6ad$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $3d3ccb41b24fd6ad$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $3d3ccb41b24fd6ad$var$order(modifiers); // order based on phase
    return (0, $9y4xT.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("fFrQ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6804799ff4220e4$export$2e2bcd8739ae039; });
function $b6804799ff4220e4$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("3hqCk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26379b44f41490ce$export$2e2bcd8739ae039; });
function $26379b44f41490ce$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("coKYj", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $906c298bc3677770$export$8f7491d57c8f97a9; });

var $kcPJk = parcelRequire("kcPJk");

var $a6g97 = parcelRequire("a6g97");

var $bTkSB = parcelRequire("bTkSB");

var $fVEtF = parcelRequire("fVEtF");

var $fUpMP = parcelRequire("fUpMP");

var $8IP3S = parcelRequire("8IP3S");

var $eOgWD = parcelRequire("eOgWD");

var $eqP9q = parcelRequire("eqP9q");

var $goZPI = parcelRequire("goZPI");

var $fBHN2 = parcelRequire("fBHN2");


var $906c298bc3677770$export$d34966752335dd47 = [
    (0, $a6g97.default),
    (0, $bTkSB.default),
    (0, $fVEtF.default),
    (0, $fUpMP.default),
    (0, $8IP3S.default),
    (0, $eOgWD.default),
    (0, $eqP9q.default),
    (0, $goZPI.default),
    (0, $fBHN2.default)
];
var $906c298bc3677770$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $kcPJk.popperGenerator)({
    defaultModifiers: $906c298bc3677770$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("idR5b", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $d4429dfc766a09ea$export$8f7491d57c8f97a9; });

var $kcPJk = parcelRequire("kcPJk");

var $a6g97 = parcelRequire("a6g97");

var $bTkSB = parcelRequire("bTkSB");

var $fVEtF = parcelRequire("fVEtF");

var $fUpMP = parcelRequire("fUpMP");
var $d4429dfc766a09ea$export$d34966752335dd47 = [
    (0, $a6g97.default),
    (0, $bTkSB.default),
    (0, $fVEtF.default),
    (0, $fUpMP.default)
];
var $d4429dfc766a09ea$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $kcPJk.popperGenerator)({
    defaultModifiers: $d4429dfc766a09ea$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});


//
// Scripts
//
var $5b80e0a116d64ecd$exports = {};





/*!
  * Bootstrap collapse.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $5b80e0a116d64ecd$exports = factory((parcelRequire("alWdG")), (parcelRequire("fKNxC")), (parcelRequire("jB4uE")), (parcelRequire("dDQCV")), (parcelRequire("1qjah")));
})($5b80e0a116d64ecd$exports, function(Data, EventHandler, Manipulator, SelectorEngine, BaseComponent) {
    "use strict";
    const _interopDefaultLegacy = (e)=>e && typeof e === "object" && "default" in e ? e : {
            default: e
        };
    const Data__default = /*#__PURE__*/ _interopDefaultLegacy(Data);
    const EventHandler__default = /*#__PURE__*/ _interopDefaultLegacy(EventHandler);
    const Manipulator__default = /*#__PURE__*/ _interopDefaultLegacy(Manipulator);
    const SelectorEngine__default = /*#__PURE__*/ _interopDefaultLegacy(SelectorEngine);
    const BaseComponent__default = /*#__PURE__*/ _interopDefaultLegacy(BaseComponent);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const toType = (obj)=>{
        if (obj === null || obj === undefined) return `${obj}`;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    const getSelector = (element)=>{
        let selector = element.getAttribute("data-bs-target");
        if (!selector || selector === "#") {
            let hrefAttr = element.getAttribute("href"); // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttr || !hrefAttr.includes("#") && !hrefAttr.startsWith(".")) return null;
             // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttr.includes("#") && !hrefAttr.startsWith("#")) hrefAttr = `#${hrefAttr.split("#")[1]}`;
            selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : null;
        }
        return selector;
    };
    const getSelectorFromElement = (element)=>{
        const selector = getSelector(element);
        if (selector) return document.querySelector(selector) ? selector : null;
        return null;
    };
    const getElementFromSelector = (element)=>{
        const selector = getSelector(element);
        return selector ? document.querySelector(selector) : null;
    };
    const isElement = (obj)=>{
        if (!obj || typeof obj !== "object") return false;
        if (typeof obj.jquery !== "undefined") obj = obj[0];
        return typeof obj.nodeType !== "undefined";
    };
    const getElement = (obj)=>{
        if (isElement(obj)) // it's a jQuery object or a node element
        return obj.jquery ? obj[0] : obj;
        if (typeof obj === "string" && obj.length > 0) return document.querySelector(obj);
        return null;
    };
    const typeCheckConfig = (componentName, config, configTypes)=>{
        Object.keys(configTypes).forEach((property)=>{
            const expectedTypes = configTypes[property];
            const value = config[property];
            const valueType = value && isElement(value) ? "element" : toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${componentName.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        });
    };
    /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */ const reflow = (element)=>{
        // eslint-disable-next-line no-unused-expressions
        element.offsetHeight;
    };
    const getjQuery = ()=>{
        const { jQuery: jQuery } = window;
        if (jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === "loading") {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
                DOMContentLoadedCallbacks.forEach((callback)=>callback());
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const NAME = "collapse";
    const DATA_KEY = "bs.collapse";
    const EVENT_KEY = `.${DATA_KEY}`;
    const DATA_API_KEY = ".data-api";
    const Default = {
        toggle: true,
        parent: null
    };
    const DefaultType = {
        toggle: "boolean",
        parent: "(null|element)"
    };
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`;
    const CLASS_NAME_SHOW = "show";
    const CLASS_NAME_COLLAPSE = "collapse";
    const CLASS_NAME_COLLAPSING = "collapsing";
    const CLASS_NAME_COLLAPSED = "collapsed";
    const CLASS_NAME_DEEPER_CHILDREN = `:scope .${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`;
    const CLASS_NAME_HORIZONTAL = "collapse-horizontal";
    const WIDTH = "width";
    const HEIGHT = "height";
    const SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
    const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="collapse"]';
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ class Collapse extends BaseComponent__default.default {
        constructor(element, config){
            super(element);
            this._isTransitioning = false;
            this._config = this._getConfig(config);
            this._triggerArray = [];
            const toggleList = SelectorEngine__default.default.find(SELECTOR_DATA_TOGGLE);
            for(let i = 0, len = toggleList.length; i < len; i++){
                const elem = toggleList[i];
                const selector = getSelectorFromElement(elem);
                const filterElement = SelectorEngine__default.default.find(selector).filter((foundElem)=>foundElem === this._element);
                if (selector !== null && filterElement.length) {
                    this._selector = selector;
                    this._triggerArray.push(elem);
                }
            }
            this._initializeChildren();
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
            if (this._config.toggle) this.toggle();
        }
        static get Default() {
            return Default;
        }
        static get NAME() {
            return NAME;
        }
        toggle() {
            if (this._isShown()) this.hide();
            else this.show();
        }
        show() {
            if (this._isTransitioning || this._isShown()) return;
            let actives = [];
            let activesData;
            if (this._config.parent) {
                const children = SelectorEngine__default.default.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
                actives = SelectorEngine__default.default.find(SELECTOR_ACTIVES, this._config.parent).filter((elem)=>!children.includes(elem)); // remove children if greater depth
            }
            const container = SelectorEngine__default.default.findOne(this._selector);
            if (actives.length) {
                const tempActiveData = actives.find((elem)=>container !== elem);
                activesData = tempActiveData ? Collapse.getInstance(tempActiveData) : null;
                if (activesData && activesData._isTransitioning) return;
            }
            const startEvent = EventHandler__default.default.trigger(this._element, EVENT_SHOW);
            if (startEvent.defaultPrevented) return;
            actives.forEach((elemActive)=>{
                if (container !== elemActive) Collapse.getOrCreateInstance(elemActive, {
                    toggle: false
                }).hide();
                if (!activesData) Data__default.default.set(elemActive, DATA_KEY, null);
            });
            const dimension = this._getDimension();
            this._element.classList.remove(CLASS_NAME_COLLAPSE);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.style[dimension] = 0;
            this._addAriaAndCollapsedClass(this._triggerArray, true);
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW);
                this._element.style[dimension] = "";
                EventHandler__default.default.trigger(this._element, EVENT_SHOWN);
            };
            const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            const scrollSize = `scroll${capitalizedDimension}`;
            this._queueCallback(complete, this._element, true);
            this._element.style[dimension] = `${this._element[scrollSize]}px`;
        }
        hide() {
            if (this._isTransitioning || !this._isShown()) return;
            const startEvent = EventHandler__default.default.trigger(this._element, EVENT_HIDE);
            if (startEvent.defaultPrevented) return;
            const dimension = this._getDimension();
            this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW);
            const triggerArrayLength = this._triggerArray.length;
            for(let i = 0; i < triggerArrayLength; i++){
                const trigger = this._triggerArray[i];
                const elem = getElementFromSelector(trigger);
                if (elem && !this._isShown(elem)) this._addAriaAndCollapsedClass([
                    trigger
                ], false);
            }
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE);
                EventHandler__default.default.trigger(this._element, EVENT_HIDDEN);
            };
            this._element.style[dimension] = "";
            this._queueCallback(complete, this._element, true);
        }
        _isShown(element = this._element) {
            return element.classList.contains(CLASS_NAME_SHOW);
        }
        _getConfig(config) {
            config = {
                ...Default,
                ...Manipulator__default.default.getDataAttributes(this._element),
                ...config
            };
            config.toggle = Boolean(config.toggle); // Coerce string values
            config.parent = getElement(config.parent);
            typeCheckConfig(NAME, config, DefaultType);
            return config;
        }
        _getDimension() {
            return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
        }
        _initializeChildren() {
            if (!this._config.parent) return;
            const children = SelectorEngine__default.default.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
            SelectorEngine__default.default.find(SELECTOR_DATA_TOGGLE, this._config.parent).filter((elem)=>!children.includes(elem)).forEach((element)=>{
                const selected = getElementFromSelector(element);
                if (selected) this._addAriaAndCollapsedClass([
                    element
                ], this._isShown(selected));
            });
        }
        _addAriaAndCollapsedClass(triggerArray, isOpen) {
            if (!triggerArray.length) return;
            triggerArray.forEach((elem)=>{
                if (isOpen) elem.classList.remove(CLASS_NAME_COLLAPSED);
                else elem.classList.add(CLASS_NAME_COLLAPSED);
                elem.setAttribute("aria-expanded", isOpen);
            });
        }
        static jQueryInterface(config) {
            return this.each(function() {
                const _config = {};
                if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
                const data = Collapse.getOrCreateInstance(this, _config);
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                    data[config]();
                }
            });
        }
    }
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ EventHandler__default.default.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
        const selector = getSelectorFromElement(this);
        const selectorElements = SelectorEngine__default.default.find(selector);
        selectorElements.forEach((element)=>{
            Collapse.getOrCreateInstance(element, {
                toggle: false
            }).toggle();
        });
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   * add .Collapse to jQuery only if jQuery is present
   */ defineJQueryPlugin(Collapse);
    return Collapse;
});


var $d5cb70d96cd14b01$exports = {};





/*!
  * Bootstrap dropdown.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $d5cb70d96cd14b01$exports = factory((parcelRequire("sxHqA")), (parcelRequire("fKNxC")), (parcelRequire("jB4uE")), (parcelRequire("dDQCV")), (parcelRequire("1qjah")));
})($d5cb70d96cd14b01$exports, function(Popper, EventHandler, Manipulator, SelectorEngine, BaseComponent) {
    "use strict";
    const _interopDefaultLegacy = (e)=>e && typeof e === "object" && "default" in e ? e : {
            default: e
        };
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        const n = Object.create(null);
        if (e) {
            for(const k in e)if (k !== "default") {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: ()=>e[k]
                });
            }
        }
        n.default = e;
        return Object.freeze(n);
    }
    const Popper__namespace = /*#__PURE__*/ _interopNamespace(Popper);
    const EventHandler__default = /*#__PURE__*/ _interopDefaultLegacy(EventHandler);
    const Manipulator__default = /*#__PURE__*/ _interopDefaultLegacy(Manipulator);
    const SelectorEngine__default = /*#__PURE__*/ _interopDefaultLegacy(SelectorEngine);
    const BaseComponent__default = /*#__PURE__*/ _interopDefaultLegacy(BaseComponent);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const toType = (obj)=>{
        if (obj === null || obj === undefined) return `${obj}`;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    const getSelector = (element)=>{
        let selector = element.getAttribute("data-bs-target");
        if (!selector || selector === "#") {
            let hrefAttr = element.getAttribute("href"); // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttr || !hrefAttr.includes("#") && !hrefAttr.startsWith(".")) return null;
             // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttr.includes("#") && !hrefAttr.startsWith("#")) hrefAttr = `#${hrefAttr.split("#")[1]}`;
            selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : null;
        }
        return selector;
    };
    const getElementFromSelector = (element)=>{
        const selector = getSelector(element);
        return selector ? document.querySelector(selector) : null;
    };
    const isElement = (obj)=>{
        if (!obj || typeof obj !== "object") return false;
        if (typeof obj.jquery !== "undefined") obj = obj[0];
        return typeof obj.nodeType !== "undefined";
    };
    const getElement = (obj)=>{
        if (isElement(obj)) // it's a jQuery object or a node element
        return obj.jquery ? obj[0] : obj;
        if (typeof obj === "string" && obj.length > 0) return document.querySelector(obj);
        return null;
    };
    const typeCheckConfig = (componentName, config, configTypes)=>{
        Object.keys(configTypes).forEach((property)=>{
            const expectedTypes = configTypes[property];
            const value = config[property];
            const valueType = value && isElement(value) ? "element" : toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${componentName.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        });
    };
    const isVisible = (element)=>{
        if (!isElement(element) || element.getClientRects().length === 0) return false;
        return getComputedStyle(element).getPropertyValue("visibility") === "visible";
    };
    const isDisabled = (element)=>{
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains("disabled")) return true;
        if (typeof element.disabled !== "undefined") return element.disabled;
        return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
    };
    const noop = ()=>{};
    const getjQuery = ()=>{
        const { jQuery: jQuery } = window;
        if (jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === "loading") {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
                DOMContentLoadedCallbacks.forEach((callback)=>callback());
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const isRTL = ()=>document.documentElement.dir === "rtl";
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    /**
   * Return the previous/next element of a list.
   *
   * @param {array} list    The list of elements
   * @param activeElement   The active element
   * @param shouldGetNext   Choose to get next or previous element
   * @param isCycleAllowed
   * @return {Element|elem} The proper element
   */ const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
        let index = list.indexOf(activeElement); // if the element does not exist in the list return an element depending on the direction and if cycle is allowed
        if (index === -1) return list[!shouldGetNext && isCycleAllowed ? list.length - 1 : 0];
        const listLength = list.length;
        index += shouldGetNext ? 1 : -1;
        if (isCycleAllowed) index = (index + listLength) % listLength;
        return list[Math.max(0, Math.min(index, listLength - 1))];
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dropdown.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const NAME = "dropdown";
    const DATA_KEY = "bs.dropdown";
    const EVENT_KEY = `.${DATA_KEY}`;
    const DATA_API_KEY = ".data-api";
    const ESCAPE_KEY = "Escape";
    const SPACE_KEY = "Space";
    const TAB_KEY = "Tab";
    const ARROW_UP_KEY = "ArrowUp";
    const ARROW_DOWN_KEY = "ArrowDown";
    const RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
    const REGEXP_KEYDOWN = new RegExp(`${ARROW_UP_KEY}|${ARROW_DOWN_KEY}|${ESCAPE_KEY}`);
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`;
    const EVENT_KEYDOWN_DATA_API = `keydown${EVENT_KEY}${DATA_API_KEY}`;
    const EVENT_KEYUP_DATA_API = `keyup${EVENT_KEY}${DATA_API_KEY}`;
    const CLASS_NAME_SHOW = "show";
    const CLASS_NAME_DROPUP = "dropup";
    const CLASS_NAME_DROPEND = "dropend";
    const CLASS_NAME_DROPSTART = "dropstart";
    const CLASS_NAME_NAVBAR = "navbar";
    const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="dropdown"]';
    const SELECTOR_MENU = ".dropdown-menu";
    const SELECTOR_NAVBAR_NAV = ".navbar-nav";
    const SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
    const PLACEMENT_TOP = isRTL() ? "top-end" : "top-start";
    const PLACEMENT_TOPEND = isRTL() ? "top-start" : "top-end";
    const PLACEMENT_BOTTOM = isRTL() ? "bottom-end" : "bottom-start";
    const PLACEMENT_BOTTOMEND = isRTL() ? "bottom-start" : "bottom-end";
    const PLACEMENT_RIGHT = isRTL() ? "left-start" : "right-start";
    const PLACEMENT_LEFT = isRTL() ? "right-start" : "left-start";
    const Default = {
        offset: [
            0,
            2
        ],
        boundary: "clippingParents",
        reference: "toggle",
        display: "dynamic",
        popperConfig: null,
        autoClose: true
    };
    const DefaultType = {
        offset: "(array|string|function)",
        boundary: "(string|element)",
        reference: "(string|element|object)",
        display: "string",
        popperConfig: "(null|object|function)",
        autoClose: "(boolean|string)"
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ class Dropdown extends BaseComponent__default.default {
        constructor(element, config){
            super(element);
            this._popper = null;
            this._config = this._getConfig(config);
            this._menu = this._getMenuElement();
            this._inNavbar = this._detectNavbar();
        }
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        toggle() {
            return this._isShown() ? this.hide() : this.show();
        }
        show() {
            if (isDisabled(this._element) || this._isShown(this._menu)) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            const showEvent = EventHandler__default.default.trigger(this._element, EVENT_SHOW, relatedTarget);
            if (showEvent.defaultPrevented) return;
            const parent = Dropdown.getParentFromElement(this._element); // Totally disable Popper for Dropdowns in Navbar
            if (this._inNavbar) Manipulator__default.default.setDataAttribute(this._menu, "popper", "none");
            else this._createPopper(parent);
             // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ("ontouchstart" in document.documentElement && !parent.closest(SELECTOR_NAVBAR_NAV)) [].concat(...document.body.children).forEach((elem)=>EventHandler__default.default.on(elem, "mouseover", noop));
            this._element.focus();
            this._element.setAttribute("aria-expanded", true);
            this._menu.classList.add(CLASS_NAME_SHOW);
            this._element.classList.add(CLASS_NAME_SHOW);
            EventHandler__default.default.trigger(this._element, EVENT_SHOWN, relatedTarget);
        }
        hide() {
            if (isDisabled(this._element) || !this._isShown(this._menu)) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            this._completeHide(relatedTarget);
        }
        dispose() {
            if (this._popper) this._popper.destroy();
            super.dispose();
        }
        update() {
            this._inNavbar = this._detectNavbar();
            if (this._popper) this._popper.update();
        }
        _completeHide(relatedTarget) {
            const hideEvent = EventHandler__default.default.trigger(this._element, EVENT_HIDE, relatedTarget);
            if (hideEvent.defaultPrevented) return;
             // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ("ontouchstart" in document.documentElement) [].concat(...document.body.children).forEach((elem)=>EventHandler__default.default.off(elem, "mouseover", noop));
            if (this._popper) this._popper.destroy();
            this._menu.classList.remove(CLASS_NAME_SHOW);
            this._element.classList.remove(CLASS_NAME_SHOW);
            this._element.setAttribute("aria-expanded", "false");
            Manipulator__default.default.removeDataAttribute(this._menu, "popper");
            EventHandler__default.default.trigger(this._element, EVENT_HIDDEN, relatedTarget);
        }
        _getConfig(config) {
            config = {
                ...this.constructor.Default,
                ...Manipulator__default.default.getDataAttributes(this._element),
                ...config
            };
            typeCheckConfig(NAME, config, this.constructor.DefaultType);
            if (typeof config.reference === "object" && !isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
            throw new TypeError(`${NAME.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
            return config;
        }
        _createPopper(parent) {
            if (typeof Popper__namespace === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
            let referenceElement = this._element;
            if (this._config.reference === "parent") referenceElement = parent;
            else if (isElement(this._config.reference)) referenceElement = getElement(this._config.reference);
            else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
            const popperConfig = this._getPopperConfig();
            const isDisplayStatic = popperConfig.modifiers.find((modifier)=>modifier.name === "applyStyles" && modifier.enabled === false);
            this._popper = Popper__namespace.createPopper(referenceElement, this._menu, popperConfig);
            if (isDisplayStatic) Manipulator__default.default.setDataAttribute(this._menu, "popper", "static");
        }
        _isShown(element = this._element) {
            return element.classList.contains(CLASS_NAME_SHOW);
        }
        _getMenuElement() {
            return SelectorEngine__default.default.next(this._element, SELECTOR_MENU)[0];
        }
        _getPlacement() {
            const parentDropdown = this._element.parentNode;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) return PLACEMENT_RIGHT;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) return PLACEMENT_LEFT;
             // We need to trim the value because custom properties can also include spaces
            const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
            if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
            return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
        }
        _detectNavbar() {
            return this._element.closest(`.${CLASS_NAME_NAVBAR}`) !== null;
        }
        _getOffset() {
            const { offset: offset } = this._config;
            if (typeof offset === "string") return offset.split(",").map((val)=>Number.parseInt(val, 10));
            if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
            return offset;
        }
        _getPopperConfig() {
            const defaultBsPopperConfig = {
                placement: this._getPlacement(),
                modifiers: [
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: this._getOffset()
                        }
                    }
                ]
            }; // Disable Popper if we have a static display
            if (this._config.display === "static") defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
            return {
                ...defaultBsPopperConfig,
                ...typeof this._config.popperConfig === "function" ? this._config.popperConfig(defaultBsPopperConfig) : this._config.popperConfig
            };
        }
        _selectMenuItem({ key: key, target: target }) {
            const items = SelectorEngine__default.default.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter(isVisible);
            if (!items.length) return;
             // if target isn't included in items (e.g. when expanding the dropdown)
            // allow cycling to get the last item in case key equals ARROW_UP_KEY
            getNextActiveElement(items, target, key === ARROW_DOWN_KEY, !items.includes(target)).focus();
        }
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Dropdown.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        static clearMenus(event) {
            if (event && (event.button === RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== TAB_KEY)) return;
            const toggles = SelectorEngine__default.default.find(SELECTOR_DATA_TOGGLE);
            for(let i = 0, len = toggles.length; i < len; i++){
                const context = Dropdown.getInstance(toggles[i]);
                if (!context || context._config.autoClose === false) continue;
                if (!context._isShown()) continue;
                const relatedTarget = {
                    relatedTarget: context._element
                };
                if (event) {
                    const composedPath = event.composedPath();
                    const isMenuTarget = composedPath.includes(context._menu);
                    if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
                     // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                    if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === TAB_KEY || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                    if (event.type === "click") relatedTarget.clickEvent = event;
                }
                context._completeHide(relatedTarget);
            }
        }
        static getParentFromElement(element) {
            return getElementFromSelector(element) || element.parentNode;
        }
        static dataApiKeydownHandler(event) {
            // If not input/textarea:
            //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
            // If input/textarea:
            //  - If space key => not a dropdown command
            //  - If key is other than escape
            //    - If key is not up or down => not a dropdown command
            //    - If trigger inside the menu => not a dropdown command
            if (/input|textarea/i.test(event.target.tagName) ? event.key === SPACE_KEY || event.key !== ESCAPE_KEY && (event.key !== ARROW_DOWN_KEY && event.key !== ARROW_UP_KEY || event.target.closest(SELECTOR_MENU)) : !REGEXP_KEYDOWN.test(event.key)) return;
            const isActive = this.classList.contains(CLASS_NAME_SHOW);
            if (!isActive && event.key === ESCAPE_KEY) return;
            event.preventDefault();
            event.stopPropagation();
            if (isDisabled(this)) return;
            const getToggleButton = this.matches(SELECTOR_DATA_TOGGLE) ? this : SelectorEngine__default.default.prev(this, SELECTOR_DATA_TOGGLE)[0];
            const instance = Dropdown.getOrCreateInstance(getToggleButton);
            if (event.key === ESCAPE_KEY) {
                instance.hide();
                return;
            }
            if (event.key === ARROW_UP_KEY || event.key === ARROW_DOWN_KEY) {
                if (!isActive) instance.show();
                instance._selectMenuItem(event);
                return;
            }
            if (!isActive || event.key === SPACE_KEY) Dropdown.clearMenus();
        }
    }
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ EventHandler__default.default.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE, Dropdown.dataApiKeydownHandler);
    EventHandler__default.default.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
    EventHandler__default.default.on(document, EVENT_CLICK_DATA_API, Dropdown.clearMenus);
    EventHandler__default.default.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
    EventHandler__default.default.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        event.preventDefault();
        Dropdown.getOrCreateInstance(this).toggle();
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   * add .Dropdown to jQuery only if jQuery is present
   */ defineJQueryPlugin(Dropdown);
    return Dropdown;
});


var $5db06b2d0272414b$exports = {};




/*!
  * Bootstrap scrollspy.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $5db06b2d0272414b$exports = factory((parcelRequire("fKNxC")), (parcelRequire("jB4uE")), (parcelRequire("dDQCV")), (parcelRequire("1qjah")));
})($5db06b2d0272414b$exports, function(EventHandler, Manipulator, SelectorEngine, BaseComponent) {
    "use strict";
    const _interopDefaultLegacy = (e)=>e && typeof e === "object" && "default" in e ? e : {
            default: e
        };
    const EventHandler__default = /*#__PURE__*/ _interopDefaultLegacy(EventHandler);
    const Manipulator__default = /*#__PURE__*/ _interopDefaultLegacy(Manipulator);
    const SelectorEngine__default = /*#__PURE__*/ _interopDefaultLegacy(SelectorEngine);
    const BaseComponent__default = /*#__PURE__*/ _interopDefaultLegacy(BaseComponent);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const toType = (obj)=>{
        if (obj === null || obj === undefined) return `${obj}`;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    const getSelector = (element)=>{
        let selector = element.getAttribute("data-bs-target");
        if (!selector || selector === "#") {
            let hrefAttr = element.getAttribute("href"); // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttr || !hrefAttr.includes("#") && !hrefAttr.startsWith(".")) return null;
             // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttr.includes("#") && !hrefAttr.startsWith("#")) hrefAttr = `#${hrefAttr.split("#")[1]}`;
            selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : null;
        }
        return selector;
    };
    const getSelectorFromElement = (element)=>{
        const selector = getSelector(element);
        if (selector) return document.querySelector(selector) ? selector : null;
        return null;
    };
    const isElement = (obj)=>{
        if (!obj || typeof obj !== "object") return false;
        if (typeof obj.jquery !== "undefined") obj = obj[0];
        return typeof obj.nodeType !== "undefined";
    };
    const getElement = (obj)=>{
        if (isElement(obj)) // it's a jQuery object or a node element
        return obj.jquery ? obj[0] : obj;
        if (typeof obj === "string" && obj.length > 0) return document.querySelector(obj);
        return null;
    };
    const typeCheckConfig = (componentName, config, configTypes)=>{
        Object.keys(configTypes).forEach((property)=>{
            const expectedTypes = configTypes[property];
            const value = config[property];
            const valueType = value && isElement(value) ? "element" : toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${componentName.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        });
    };
    const getjQuery = ()=>{
        const { jQuery: jQuery } = window;
        if (jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === "loading") {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
                DOMContentLoadedCallbacks.forEach((callback)=>callback());
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): scrollspy.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const NAME = "scrollspy";
    const DATA_KEY = "bs.scrollspy";
    const EVENT_KEY = `.${DATA_KEY}`;
    const DATA_API_KEY = ".data-api";
    const Default = {
        offset: 10,
        method: "auto",
        target: ""
    };
    const DefaultType = {
        offset: "number",
        method: "string",
        target: "(string|element)"
    };
    const EVENT_ACTIVATE = `activate${EVENT_KEY}`;
    const EVENT_SCROLL = `scroll${EVENT_KEY}`;
    const EVENT_LOAD_DATA_API = `load${EVENT_KEY}${DATA_API_KEY}`;
    const CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
    const CLASS_NAME_ACTIVE = "active";
    const SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
    const SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
    const SELECTOR_NAV_LINKS = ".nav-link";
    const SELECTOR_NAV_ITEMS = ".nav-item";
    const SELECTOR_LIST_ITEMS = ".list-group-item";
    const SELECTOR_LINK_ITEMS = `${SELECTOR_NAV_LINKS}, ${SELECTOR_LIST_ITEMS}, .${CLASS_NAME_DROPDOWN_ITEM}`;
    const SELECTOR_DROPDOWN = ".dropdown";
    const SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
    const METHOD_OFFSET = "offset";
    const METHOD_POSITION = "position";
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ class ScrollSpy extends BaseComponent__default.default {
        constructor(element, config){
            super(element);
            this._scrollElement = this._element.tagName === "BODY" ? window : this._element;
            this._config = this._getConfig(config);
            this._offsets = [];
            this._targets = [];
            this._activeTarget = null;
            this._scrollHeight = 0;
            EventHandler__default.default.on(this._scrollElement, EVENT_SCROLL, ()=>this._process());
            this.refresh();
            this._process();
        }
        static get Default() {
            return Default;
        }
        static get NAME() {
            return NAME;
        }
        refresh() {
            const autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
            const offsetMethod = this._config.method === "auto" ? autoMethod : this._config.method;
            const offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
            this._offsets = [];
            this._targets = [];
            this._scrollHeight = this._getScrollHeight();
            const targets = SelectorEngine__default.default.find(SELECTOR_LINK_ITEMS, this._config.target);
            targets.map((element)=>{
                const targetSelector = getSelectorFromElement(element);
                const target = targetSelector ? SelectorEngine__default.default.findOne(targetSelector) : null;
                if (target) {
                    const targetBCR = target.getBoundingClientRect();
                    if (targetBCR.width || targetBCR.height) return [
                        Manipulator__default.default[offsetMethod](target).top + offsetBase,
                        targetSelector
                    ];
                }
                return null;
            }).filter((item)=>item).sort((a, b)=>a[0] - b[0]).forEach((item)=>{
                this._offsets.push(item[0]);
                this._targets.push(item[1]);
            });
        }
        dispose() {
            EventHandler__default.default.off(this._scrollElement, EVENT_KEY);
            super.dispose();
        }
        _getConfig(config) {
            config = {
                ...Default,
                ...Manipulator__default.default.getDataAttributes(this._element),
                ...typeof config === "object" && config ? config : {}
            };
            config.target = getElement(config.target) || document.documentElement;
            typeCheckConfig(NAME, config, DefaultType);
            return config;
        }
        _getScrollTop() {
            return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
        }
        _getScrollHeight() {
            return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        }
        _getOffsetHeight() {
            return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
        }
        _process() {
            const scrollTop = this._getScrollTop() + this._config.offset;
            const scrollHeight = this._getScrollHeight();
            const maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();
            if (this._scrollHeight !== scrollHeight) this.refresh();
            if (scrollTop >= maxScroll) {
                const target = this._targets[this._targets.length - 1];
                if (this._activeTarget !== target) this._activate(target);
                return;
            }
            if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
                this._activeTarget = null;
                this._clear();
                return;
            }
            for(let i = this._offsets.length; i--;){
                const isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === "undefined" || scrollTop < this._offsets[i + 1]);
                if (isActiveTarget) this._activate(this._targets[i]);
            }
        }
        _activate(target) {
            this._activeTarget = target;
            this._clear();
            const queries = SELECTOR_LINK_ITEMS.split(",").map((selector)=>`${selector}[data-bs-target="${target}"],${selector}[href="${target}"]`);
            const link = SelectorEngine__default.default.findOne(queries.join(","), this._config.target);
            link.classList.add(CLASS_NAME_ACTIVE);
            if (link.classList.contains(CLASS_NAME_DROPDOWN_ITEM)) SelectorEngine__default.default.findOne(SELECTOR_DROPDOWN_TOGGLE, link.closest(SELECTOR_DROPDOWN)).classList.add(CLASS_NAME_ACTIVE);
            else SelectorEngine__default.default.parents(link, SELECTOR_NAV_LIST_GROUP).forEach((listGroup)=>{
                // Set triggered links parents as active
                // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                SelectorEngine__default.default.prev(listGroup, `${SELECTOR_NAV_LINKS}, ${SELECTOR_LIST_ITEMS}`).forEach((item)=>item.classList.add(CLASS_NAME_ACTIVE)); // Handle special case when .nav-link is inside .nav-item
                SelectorEngine__default.default.prev(listGroup, SELECTOR_NAV_ITEMS).forEach((navItem)=>{
                    SelectorEngine__default.default.children(navItem, SELECTOR_NAV_LINKS).forEach((item)=>item.classList.add(CLASS_NAME_ACTIVE));
                });
            });
            EventHandler__default.default.trigger(this._scrollElement, EVENT_ACTIVATE, {
                relatedTarget: target
            });
        }
        _clear() {
            SelectorEngine__default.default.find(SELECTOR_LINK_ITEMS, this._config.target).filter((node)=>node.classList.contains(CLASS_NAME_ACTIVE)).forEach((node)=>node.classList.remove(CLASS_NAME_ACTIVE));
        }
        static jQueryInterface(config) {
            return this.each(function() {
                const data = ScrollSpy.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
    }
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ EventHandler__default.default.on(window, EVENT_LOAD_DATA_API, ()=>{
        SelectorEngine__default.default.find(SELECTOR_DATA_SPY).forEach((spy)=>new ScrollSpy(spy));
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   * add .ScrollSpy to jQuery only if jQuery is present
   */ defineJQueryPlugin(ScrollSpy);
    return ScrollSpy;
});


var $b61b7c01cdd52dd6$exports = {};



/*!
  * Bootstrap toast.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $b61b7c01cdd52dd6$exports = factory((parcelRequire("fKNxC")), (parcelRequire("jB4uE")), (parcelRequire("1qjah")));
})($b61b7c01cdd52dd6$exports, function(EventHandler, Manipulator, BaseComponent) {
    "use strict";
    const _interopDefaultLegacy = (e)=>e && typeof e === "object" && "default" in e ? e : {
            default: e
        };
    const EventHandler__default = /*#__PURE__*/ _interopDefaultLegacy(EventHandler);
    const Manipulator__default = /*#__PURE__*/ _interopDefaultLegacy(Manipulator);
    const BaseComponent__default = /*#__PURE__*/ _interopDefaultLegacy(BaseComponent);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const toType = (obj)=>{
        if (obj === null || obj === undefined) return `${obj}`;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    const getSelector = (element)=>{
        let selector = element.getAttribute("data-bs-target");
        if (!selector || selector === "#") {
            let hrefAttr = element.getAttribute("href"); // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttr || !hrefAttr.includes("#") && !hrefAttr.startsWith(".")) return null;
             // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttr.includes("#") && !hrefAttr.startsWith("#")) hrefAttr = `#${hrefAttr.split("#")[1]}`;
            selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : null;
        }
        return selector;
    };
    const getElementFromSelector = (element)=>{
        const selector = getSelector(element);
        return selector ? document.querySelector(selector) : null;
    };
    const isElement = (obj)=>{
        if (!obj || typeof obj !== "object") return false;
        if (typeof obj.jquery !== "undefined") obj = obj[0];
        return typeof obj.nodeType !== "undefined";
    };
    const typeCheckConfig = (componentName, config, configTypes)=>{
        Object.keys(configTypes).forEach((property)=>{
            const expectedTypes = configTypes[property];
            const value = config[property];
            const valueType = value && isElement(value) ? "element" : toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${componentName.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        });
    };
    const isDisabled = (element)=>{
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains("disabled")) return true;
        if (typeof element.disabled !== "undefined") return element.disabled;
        return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
    };
    /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */ const reflow = (element)=>{
        // eslint-disable-next-line no-unused-expressions
        element.offsetHeight;
    };
    const getjQuery = ()=>{
        const { jQuery: jQuery } = window;
        if (jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === "loading") {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
                DOMContentLoadedCallbacks.forEach((callback)=>callback());
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/component-functions.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const enableDismissTrigger = (component, method = "hide")=>{
        const clickEvent = `click.dismiss${component.EVENT_KEY}`;
        const name = component.NAME;
        EventHandler__default.default.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
            if ([
                "A",
                "AREA"
            ].includes(this.tagName)) event.preventDefault();
            if (isDisabled(this)) return;
            const target = getElementFromSelector(this) || this.closest(`.${name}`);
            const instance = component.getOrCreateInstance(target); // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
            instance[method]();
        });
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): toast.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const NAME = "toast";
    const DATA_KEY = "bs.toast";
    const EVENT_KEY = `.${DATA_KEY}`;
    const EVENT_MOUSEOVER = `mouseover${EVENT_KEY}`;
    const EVENT_MOUSEOUT = `mouseout${EVENT_KEY}`;
    const EVENT_FOCUSIN = `focusin${EVENT_KEY}`;
    const EVENT_FOCUSOUT = `focusout${EVENT_KEY}`;
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const CLASS_NAME_FADE = "fade";
    const CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
    const CLASS_NAME_SHOW = "show";
    const CLASS_NAME_SHOWING = "showing";
    const DefaultType = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    };
    const Default = {
        animation: true,
        autohide: true,
        delay: 5000
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ class Toast extends BaseComponent__default.default {
        constructor(element, config){
            super(element);
            this._config = this._getConfig(config);
            this._timeout = null;
            this._hasMouseInteraction = false;
            this._hasKeyboardInteraction = false;
            this._setListeners();
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get Default() {
            return Default;
        }
        static get NAME() {
            return NAME;
        }
        show() {
            const showEvent = EventHandler__default.default.trigger(this._element, EVENT_SHOW);
            if (showEvent.defaultPrevented) return;
            this._clearTimeout();
            if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE);
            const complete = ()=>{
                this._element.classList.remove(CLASS_NAME_SHOWING);
                EventHandler__default.default.trigger(this._element, EVENT_SHOWN);
                this._maybeScheduleHide();
            };
            this._element.classList.remove(CLASS_NAME_HIDE); // @deprecated
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOW);
            this._element.classList.add(CLASS_NAME_SHOWING);
            this._queueCallback(complete, this._element, this._config.animation);
        }
        hide() {
            if (!this._element.classList.contains(CLASS_NAME_SHOW)) return;
            const hideEvent = EventHandler__default.default.trigger(this._element, EVENT_HIDE);
            if (hideEvent.defaultPrevented) return;
            const complete = ()=>{
                this._element.classList.add(CLASS_NAME_HIDE); // @deprecated
                this._element.classList.remove(CLASS_NAME_SHOWING);
                this._element.classList.remove(CLASS_NAME_SHOW);
                EventHandler__default.default.trigger(this._element, EVENT_HIDDEN);
            };
            this._element.classList.add(CLASS_NAME_SHOWING);
            this._queueCallback(complete, this._element, this._config.animation);
        }
        dispose() {
            this._clearTimeout();
            if (this._element.classList.contains(CLASS_NAME_SHOW)) this._element.classList.remove(CLASS_NAME_SHOW);
            super.dispose();
        }
        _getConfig(config) {
            config = {
                ...Default,
                ...Manipulator__default.default.getDataAttributes(this._element),
                ...typeof config === "object" && config ? config : {}
            };
            typeCheckConfig(NAME, config, this.constructor.DefaultType);
            return config;
        }
        _maybeScheduleHide() {
            if (!this._config.autohide) return;
            if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
            this._timeout = setTimeout(()=>{
                this.hide();
            }, this._config.delay);
        }
        _onInteraction(event, isInteracting) {
            switch(event.type){
                case "mouseover":
                case "mouseout":
                    this._hasMouseInteraction = isInteracting;
                    break;
                case "focusin":
                case "focusout":
                    this._hasKeyboardInteraction = isInteracting;
                    break;
            }
            if (isInteracting) {
                this._clearTimeout();
                return;
            }
            const nextElement = event.relatedTarget;
            if (this._element === nextElement || this._element.contains(nextElement)) return;
            this._maybeScheduleHide();
        }
        _setListeners() {
            EventHandler__default.default.on(this._element, EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
            EventHandler__default.default.on(this._element, EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
            EventHandler__default.default.on(this._element, EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
            EventHandler__default.default.on(this._element, EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
        }
        _clearTimeout() {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Toast.getOrCreateInstance(this, config);
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                    data[config](this);
                }
            });
        }
    }
    enableDismissTrigger(Toast);
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   * add .Toast to jQuery only if jQuery is present
   */ defineJQueryPlugin(Toast);
    return Toast;
});


// Activate Bootstrap scrollspy on the main nav element
const $2663b6f743d16d9a$var$sideNav = document.body.querySelector("#sidenav");
if ($2663b6f743d16d9a$var$sideNav) new (0, (/*@__PURE__*/$parcel$interopDefault($5db06b2d0272414b$exports)))(document.body, {
    target: "#sidenav",
    offset: 74
});
// Collapse responsive navbar when toggler is visible
const $2663b6f743d16d9a$var$navbar = document.body.querySelector("#navbarResponsive");
const $2663b6f743d16d9a$var$navbarToggler = document.body.querySelector(".navbar-toggler");
const $2663b6f743d16d9a$var$navBrand = [].slice.call(document.querySelectorAll(".navbar-brand"));
const $2663b6f743d16d9a$var$responsiveNavItems = [].slice.call(document.querySelectorAll("#navbarResponsive .nav-link"));
[
    ...$2663b6f743d16d9a$var$navBrand,
    ...$2663b6f743d16d9a$var$responsiveNavItems
].map(function(responsiveNavItem) {
    responsiveNavItem.addEventListener("click", ()=>{
        if (window.getComputedStyle($2663b6f743d16d9a$var$navbarToggler).display !== "none" && $2663b6f743d16d9a$var$navbar.classList.contains("show")) $2663b6f743d16d9a$var$navbarToggler.click();
    });
});
// Hide Hash Fragment when scrolling to the top
// document.addEventListener('scroll', () => {
//     if (window.scrollY === 0) {
//         window.history.replaceState(null, null, ' ');
//     }
// });
// Show E-mail Toast
const $2663b6f743d16d9a$var$mailToast = document.body.querySelector("#about #mail-toast .toast");
const $2663b6f743d16d9a$var$bsMailToast = new (0, (/*@__PURE__*/$parcel$interopDefault($b61b7c01cdd52dd6$exports)))($2663b6f743d16d9a$var$mailToast);
function $2663b6f743d16d9a$var$copyMail() {
    navigator.clipboard.writeText(atob("bWFpbHRvOk1hSWwuU2hSRXlBZ0BHbUFpTC5jT20=").toLowerCase().substring(7));
    $2663b6f743d16d9a$var$mailToast.children[0].textContent = "E-mail Address Copied!";
    $2663b6f743d16d9a$var$bsMailToast.show();
}
document.getElementById("copy-mail").addEventListener("click", $2663b6f743d16d9a$var$copyMail);


//# sourceMappingURL=scripts.947c571e.js.map
